import { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';

export default function GuideAccordion({ title, children, defaultOpen = false }) {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  return (
    <div className="border-b border-white/10">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="w-full flex items-center justify-between py-4 text-left hover:text-gold transition-colors"
        data-testid={`accordion-${title.toLowerCase().replace(/\s+/g, '-')}`}
      >
        <h3 className="text-xl font-medium" style={{ fontFamily: 'Playfair Display, serif' }}>
          {title}
        </h3>
        {isOpen ? <ChevronUp size={20} className="text-gold" /> : <ChevronDown size={20} className="text-white/60" />}
      </button>
      {isOpen && (
        <div className="pb-6 text-white/70 leading-relaxed space-y-4 animate-fade-up">
          {children}
        </div>
      )}
    </div>
  );
}
